import { productShowcaseData } from '@/mocks/hoobuyData';

export default function ProductShowcase() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-10 md:mb-14">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Categorias Populares
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg">
              Explore as categorias mais procuradas no Hoobuy Spreadsheet com fornecedores verificados e links atualizados diariamente
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            Ver Todas as Categorias
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {productShowcaseData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-[10px] md:text-xs font-bold text-background-50">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mb-3 leading-relaxed">
                  {item.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                  Explorar Categoria
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-[10px]"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}